<script>
export default {
  name: "SupervisionView",
  data() {
    return {
      id: "",
      product: {},
      logo: require("../assets/xiehui.png"),
    }
  },
  created() {
    this.id = this.getParmeter("productId")
    this.productDetail(this.id);
  },
  methods: {
    productDetail(id) {
      const _this = this
      const data = {
        id: id
      }
      this.$axios.post('product/detail', data).then(function (res) {
        _this.product = res.data.data
      }).catch(function (err) {
        _this.$message.error(err)
      })
    },
    getParmeter(variable) {
      let query = window.location.href.split("?")[1];
      let vars = query.split("&");
      for (let i = 0; i < vars.length; i++) {
        let pair = vars[i].split("=");
        if (pair[0] === variable) {
          return pair[1];
        }
      }
      return "";
    },
    open(url,number) {
      console.log("传入值："+url)
      this.$router.push({
        path: '/show',
        query: {
          url: url,
          number: number
        }
      });
    }
  }
}
</script>

<template>
  <div class="home">
    <div class="main">
      <img :src="logo" style="width: 80px;height: 80px;border-radius: 40px;margin-right: 20px;"/>
      <div class="title">顺民意一品一码</div>
    </div>

    <van-image v-bind:src="product.image" class="product-image"/>
    <div class="report-title">产品信息</div>
    <van-cell-group>
      <van-cell title="产品名称:" v-bind:value="product.name" title-class="custom-title" value-class="custom-value"/>
      <van-cell title="生产商名称:" v-bind:value="product.shopName" title-class="custom-title"
                value-class="custom-value"/>
      <van-cell title="许可证编码:" v-bind:value="product.licenceNo" title-class="custom-title"
                value-class="custom-value"/>
      <van-cell title="执行标准:" v-bind:value="product.standard" title-class="custom-title"
                value-class="custom-value"/>
      <van-cell title="配料表:" v-bind:value="product.ingredients" title-class="custom-title"
                value-class="custom-value"/>
      <van-cell title="净重:" v-bind:value="product.weight" title-class="custom-title" value-class="custom-value"/>
      <van-cell title="存储方法:" v-bind:value="product.storage" title-class="custom-title" value-class="custom-value"/>
      <van-cell title="保质期:" v-bind:value="product.shelf" title-class="custom-title" value-class="custom-value"/>
      <van-cell title="质量投诉电话:" v-bind:value="product.phone" title-class="custom-title"
                value-class="custom-value"/>
<!--      <van-cell title="备注:" v-bind:label="product.remarks" label-class="remarks" title-class="custom-title"-->
<!--                value-class="custom-value"/>-->
      <div class="remarks">
        备注：{{product.remarks}}
      </div>
    </van-cell-group>
    <div>
      <div class="report-title" v-on:click="open(product.testReport,1)">
        查看检测报告
      </div>
<!--      <van-image v-bind:src="product.testReport"/>-->
    </div>

    <div style="margin-top: 5px">
      <div class="report-title"  v-on:click="open(product.technological,2)">查看产品展示</div>
<!--      <van-image v-bind:src="product.technological"/>-->
    </div>
  </div>
</template>

<style scoped>

.home {
  width: 100vw;
  height: 100vh;
  overflow-y: scroll;
}

.main {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  padding: 20px;
  background-color: #1A7AF8;
  justify-content: center; /* 水平居中 */
  align-items: center; /* 垂直居中 */
}

.product-image {
  width: 100%;
  height: 300px;
  object-fit: contain; /* 保持图片比例，完整显示 */
  background-color: #f5f5f5; /* 设置背景色避免空白区域 */
}


.van-cell {
  align-items: flex-start; /* 使单元格内容顶部对齐 */
}

.van-cell__value {
  max-width: calc(100% - 120px); /* 减去标题宽度 */
  word-wrap: break-word;
  white-space: normal;
}

.custom-title {
  flex: none;
  width: 120px;
}

.custom-value {
  flex: 1;
  text-align: left;
  min-width: 200px; /* 设置最小宽度 */
}


/* 优化后的样式 */
.title {
  font-size: 1.5rem; /* 使用相对单位更好适配 */
  color: white;
  margin-left: 20px;
  font-weight: bold; /* 增加字重提升视觉效果 */
  margin: 0; /* 移除默认margin */
}

/* 统一单元格标题样式 */
.van-cell__title {
  font-size: 20px; /* 统一标题大小 */
  font-weight: 600; /* 加粗重要信息 */
  -webkit-font-smoothing: antialiased; /* 优化字体渲染 */
}

.van-cell__value {
  font-size: 18px; /* 统一值的大小 */
  color: #333; /* 设置统一文本颜色 */
  -webkit-font-smoothing: antialiased; /* 优化字体渲染 */
}

/* 优化备注样式 */
.remarks {
  //width: 100%;
  font-size: 20px;
  color: #e64340; /* 使用品牌红色 */
  line-height: 1.5; /* 增加行高提升可读性 */
  padding: 10px 10px 10px 18px;
}

/* 分割标题样式统一 */
.section-title {
  font-size: 1.25rem;
  text-align: center;
  margin: 20px 0;
  padding: 10px;
  font-weight: bold;
}

.report-title {
  background-color: #1A7AF8;
  font-weight: bold;
  text-align: center;
  color: white;
  font-size: 1.25rem; /* 使用相对单位更好适配 */
  color: white;
  padding: 20px 0;
}

</style>
